import { useHistory } from "react-router-dom";
import { SERVER_URL } from "../ServerUrl";
import {
  ALL_BUSES_LOADED,
  ALL_BUSES_FAIL,
  ADD_BUS_SUCCESS,
  ADD_BUS_FAIL,
  UPDATE_BUS_SUCCESS,
  UPDATE_BUS_FAIL,
  REQUEST_DATA,
  UPDATE_INFANT_COUNT, UPDATE_CHILD_COUNT, UPDATE_ADULT_COUNT,
  UPDATE_REQUEST_DATA,
  ALL_CITIES
} from "./types";
// Common
import { Alert } from "../admin/common/Alert";
// Axios
import axios from "axios";
// Redux
import setAuthToken from "../admin/utils/setAuthToken";

// Get All Buses
export const getAllBuses = () => async (dispatch) => {
  if (sessionStorage.token) {
    setAuthToken(sessionStorage.token);
  }

  try {
    const res = await axios.get(`${SERVER_URL}/bus`);

    dispatch({
      type: ALL_BUSES_LOADED,
      payload: res.data.bus,
    });
  } catch (error) {
    dispatch({
      type: ALL_BUSES_FAIL,
    });
    Alert("error", "Buses are not loaded");
  }
};


export const getAllCities = () => async (dispatch) => {
  try {
    const res = await axios.get(`${SERVER_URL}/cities`);

    dispatch({
      type: ALL_CITIES,
      payload: res.data,
    });
  } catch (error) {

  }
};






export const requestInfo = (requestInfo) => {
  return (dispatch) => {
    dispatch({
      type: REQUEST_DATA,
      payload: requestInfo, // Add payload if necessary
    });
  };
};


export const UpdaterequestInfo = (requestInfor) => {
  return (dispatch) => {
    dispatch({
      type: UPDATE_REQUEST_DATA,
      payload: requestInfor, // Add payload if necessary
    });
  };
};


// Get All Buses
export const searchBuses = (requestInfor) => async (dispatch) => {
  if (sessionStorage.token) {
    setAuthToken(sessionStorage.token);
  }

  try {
    // const res = await axios.get(
    //   `${SERVER_URL}/bus/?routeFrom=${requestInfor.from}&routeTo=${requestInfor.to}&date=${requestInfor.departureDate}`
    // );
    // dispatch({
    //   type: ALL_BUSES_LOADED,
    //   payload: res.data.bus,
    // });
  } catch (error) {
    dispatch({
      type: ALL_BUSES_FAIL,
    });

    Alert("error", "Buses are not loaded");
  }
};




// Add bus
export const addBus = (bus) => async (dispatch) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  if (sessionStorage.token) {
    setAuthToken(sessionStorage.token);
  }
  const body = JSON.stringify(bus);

  try {
    const res = await axios.post(`${SERVER_URL}/bus`, body, config);

    dispatch({
      type: ADD_BUS_SUCCESS,
      payload: res.data,
    });

    Alert("success", "Bus added");
    /*  window.location.reload(); */
  } catch (error) {
    dispatch({
      type: ADD_BUS_FAIL,
    });
  }
};

// Update bus
export const updateBus =
  ({ busData, ID }) =>
    async (dispatch) => {
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      if (sessionStorage.token) {
        setAuthToken(sessionStorage.token);
      }

      const body = JSON.stringify(busData);

      try {
        const res = await axios.patch(`${SERVER_URL}/bus/${ID}`, body, config);

        dispatch({
          type: UPDATE_BUS_SUCCESS,
          payload: res.data,
        });

        Alert("success", "Bus updated");

        /*       window.location.reload(); */
      } catch (error) {
        dispatch({
          type: UPDATE_BUS_FAIL,
        });

        Alert("error", "Bus is not updated");
      }
    };
// Update seat selection
export const changeSeatSelection =
  ({ id }) =>
    async (dispatch) => {
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      if (sessionStorage.token) {
        setAuthToken(sessionStorage.token);
      }

      const body = JSON.stringify(id);

      try {

        const res = await axios.patch(
          `${SERVER_URL}/bus/changeSeatSelection/${id}`,
          /*  body, */
          config
        );

        dispatch({
          type: UPDATE_BUS_SUCCESS,
          payload: res.data,
        });

        Alert("success", "Bus updated");

        /*       window.location.reload(); */
      } catch (error) {
        dispatch({
          type: UPDATE_BUS_FAIL,
        });

        Alert("error", "Bus is not updated");
      }
    };
// Delete bus
export const deleteBus = (id) => async (dispatch) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  if (sessionStorage.token) {
    setAuthToken(sessionStorage.token);
  }

  try {
    const res = await axios.delete(`${SERVER_URL}/bus/${id}`, config);

    dispatch({
      type: UPDATE_BUS_SUCCESS,
      payload: res.data,
    });

    Alert("success", "Bus deleted");
    /*    window.location.reload(); */
  } catch (error) {
    dispatch({
      type: UPDATE_BUS_FAIL,
    });

    Alert("error", "Bus deleted");
  }
};



export const updateDepartureDate = (date) => (dispatch) => {
  dispatch({
    type: "UPDATE_DEPARTURE_DATE",
    payload: date
  });
};

export const updateTripType = (date) => (dispatch) => {
  dispatch({
    type: "UPDATE_TRIP_TYPE",
    payload: date
  });
};

export const updateDates = (departureDate, returnDate) => (dispatch) => {
  dispatch({
    type: "UPDATE_DATES",
    payload: {
      departureDate,
      returnDate
    }
  });
};


export const updateInfantCount = (count) => ({
  type: UPDATE_INFANT_COUNT,
  payload: count,
});

export const updateChildCount = (count) => ({
  type: UPDATE_CHILD_COUNT,
  payload: count,
});

export const updateAdultCount = (count) => ({
  type: UPDATE_ADULT_COUNT,
  payload: count,
});